<template>
  <page-header-wrapper>
    <div class="dashboard-editor-container">
      <div class="content-wrapper">
        <a-tabs v-model:activeKey="activeName" @change="handleClick">
          <a-tab-pane tab="模板管理" key="template">
            <div class="table-operations">
              <a-button type="primary" @click="handleTemplateAdd" v-hasPermi="['sms:template:add']">
                <a-icon type="plus" />新增</a-button
              >
            </div>
            <div class="table-content-class">
              <a-table
                :loading="loading"
                :size="tableSize"
                rowKey="id"
                :columns="templateColumns"
                :data-source="templateList"
                :pagination="false"
                :bordered="tableBordered"
              >
                <span slot="template_status" slot-scope="text, record">
                  <a-tag color="#87d068" v-if="record.template_status == 1">验证码</a-tag>
                  <a-tag type="#87d068" v-if="record.template_status == 2">通知&订单</a-tag>
                  <a-tag type="#87d068" v-if="record.template_status == 3">营销</a-tag>
                </span>
                <span slot="applyStatus" slot-scope="text, record">
                  <a-tag color="blue" v-if="record.applyStatus == 1">待审核</a-tag>
                  <a-tag color="#87d068" v-if="record.applyStatus == 2">审核通过</a-tag>
                  <a-tag color="#f50" v-if="record.applyStatus == 3">审核驳回</a-tag>
                </span>
                <span slot="operation" slot-scope="text, record">
                  <a @click="handleSendSms(record)" v-hasPermi="['sms:template:send']">测试</a>
                  <a-divider type="vertical" v-hasPermi="['sms:template:del']" />
                  <a @click="handleTemplateUpdate(record)" v-hasPermi="['sms:template:del']"> 修改 </a>
                  <a-divider type="vertical" v-hasPermi="['sms:template:del']" />
                  <a-popconfirm ok-text="是" cancel-text="否" @confirm="handleTemplateDel(record)">
                    <span slot="title"
                      >确认删除<b>{{ record.id }}</b
                      >吗?</span
                    >

                    <a v-hasPermi="['sms:template:del']"> 删除</a>
                  </a-popconfirm>
                </span>
              </a-table>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>

    <a-drawer :maskClosable="false" :visible.sync="signOpen" width="700" @close="cancelSign">
      <a-divider orientation="left">
        <b>{{ signTitle }}</b>
      </a-divider>
      <a-form-model ref="signForm" :model="signForm" :rules="signRules" laba-width="80px">
        <a-form-model-item label="签名名称" prop="sign">
          <div class="tips">
            <a-tooltip effect="light" placement="top">
              <div slot="content">
                1、接口短信最多支持10个签名。如需更多签名，请联系客服处理。<br />2、人工审核将在10分钟内完成，请耐心等待！(工作时间:8:30~21:00)
                如对审核状态有疑义，请联系客服。
              </div>
              <i class="a-icon-info">编辑须知</i>
            </a-tooltip>
          </div>
          <a-input v-model="signForm.sign" placeholder="长度限2-16个字符，建议填写真实产品名/公司简称" />
          <div class="tips">示例：天猫 招商银行 顺丰快递</div>
        </a-form-model-item>
        <a-form-model-item label="应用场景" prop="description">
          <a-input v-model="signForm.description" type="textarea" placeholder="请描述您的业务使用场景" />
        </a-form-model-item>
      </a-form-model>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" @click="submitSignForm">确 定</a-button>
          <a-button @click="cancelSign">取 消</a-button>
        </a-space>
      </div>
    </a-drawer>

    <a-drawer :maskClosable="false" :visible.sync="templateOpen" width="700" @close="cancelTemplate">
      <a-divider orientation="left">
        <b>{{ templateTitle }}</b>
      </a-divider>
      <a-form-model ref="templateForm" :model="templateForm" :rules="templateRules" laba-width="80px">
        <a-form-model-item label="模板名称" prop="name">
          <a-input v-model="templateForm.name" placeholder="请输入短信模板名称" />
        </a-form-model-item>
        <a-form-model-item label="模板类型" prop="categoryId" v-if="!templateForm.id">
          <a-radio-group v-model="templateForm.categoryId" button-style="solid">
            <a-radio-button :value="1">验证码</a-radio-button>
            <a-radio-button :value="2">通知&订单</a-radio-button>
            <a-radio-button :value="3">营销</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="产品类型" prop="appid" v-if="templateForm.id">
          <a-radio-group v-model="templateForm.appid" button-style="solid">
            <a-radio-button value="49">通知</a-radio-button>
            <a-radio-button value="52">会员营销</a-radio-button>
            <a-radio-button value="153">验证码</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="模板编码" prop="code" v-if="!templateForm.id">
          <a-input v-model="templateForm.code" placeholder="请输入模板编码" />
        </a-form-model-item>
        <a-form-model-item label="同步三方" prop="autoAddNo" v-if="!templateForm.id">
          <a-radio-group v-model="templateForm.autoAddNo" @change="handleAutoAddChange" button-style="solid">
            <a-radio-button :value="0">是</a-radio-button>
            <a-radio-button :value="1">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="同步三方" prop="syncThirdNo" v-if="templateForm.id">
          <a-radio-group v-model="templateForm.syncThirdNo" button-style="solid">
            <a-radio-button :value="0">是</a-radio-button>
            <a-radio-button :value="1">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          label="短信API模板编号"
          prop="apiTemplateId"
          v-if="!templateForm.id && templateForm.autoAddNo === 1"
        >
          <a-input v-model="templateForm.apiTemplateId" placeholder="请输入短信API模板编号，示例：4383920" />
        </a-form-model-item>
        <a-form-model-item label="模板内容" prop="content">
          <div class="tips">
            <a-tooltip effect="light" placement="top">
              <div slot="content">
                1、不支持全变量模板；
                <br />
                2、{序号}为需要接口替换的变量，变量序号从1开始，序号只允许数字；
                <br />
                3、最多支持10个变量,变量格式如{1}、{2}、{3}；
                <br />
                4、变量允许通过最长字符为20字符；
                <br />
                5、短信模板首尾不能添加[]且任意位置不能添加【】符号；
                <br />
                6、内容不用添加签名, 签名请单独申请，短信发送需要签名和短信内容；
                <br />
                人工审核将在10分钟内完成，请耐心等待！(工作时间:8:30~21:00) 如对审核状态有疑义，请联系客服。
              </div>
              <i class="a-icon-info">编辑须知</i>
            </a-tooltip>
          </div>
          <a-input
            type="textarea"
            v-model="templateForm.content"
            placeholder="请输入短信内容，链接网址必须前后空格，短信内容不能超出500个字"
          />
          <div class="tips">示例：你好，你的验证码是{1}，请在{2}分钟内使用。</div>
        </a-form-model-item>
        <a-form-model-item label="模板描述" prop="remark">
          <a-input v-model="templateForm.remark" type="textarea" placeholder="请描述您的业务使用场景" />
        </a-form-model-item>
      </a-form-model>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" @click="submitTemplateForm">确 定</a-button>
          <a-button @click="cancelTemplate">取 消</a-button>
        </a-space>
      </div>
    </a-drawer>

    <a-modal title="测试发送短信" :visible.sync="sendSmsOpen" width="500px" append-to-body @cancel="cancelSendSms">
      <a-form-model
        ref="sendSmsForm"
        :model="sendSmsForm"
        :rules="sendSmsRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="模板内容" prop="templateCode">
          <a-input v-model="sendSmsForm.content" type="textarea" placeholder="请输入模板内容" disabled />
        </a-form-model-item>
        <a-form-model-item label="手机号" prop="mobile">
          <a-input v-model="sendSmsForm.mobile" />
        </a-form-model-item>
        <a-form-model-item v-for="param in sendSmsForm.params" :key="param" :label="'参数 {' + param + '}'">
          <a-input v-model="sendSmsForm.templateParams[param]" :placeholder="'请输入 ' + param + ' 参数'" />
        </a-form-model-item>
      </a-form-model>
      <div slot="footer" class="dialog-footer">
        <a-button type="primary" @click="submitSendSmsForm">确 定</a-button>
        <a-button @click="cancelSendSms">取 消</a-button>
      </div>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { tableMixin } from '@/store/table-mixin'
import ZRPanelGroup from './ZRPanelGroup'
import Recharge from './Recharge'
import {
  getAccount,
  getSignList,
  createSign,
  updateSign,
  getTemplateList,
  delSign,
  createTemplate,
  updateTemplate,
  getTemplate,
  delTemplate,
  synTemplate,
} from '@/api/sms/zrwinfo'
import { sendSms } from '@/api/sms/template'
import { getChannel, updateChannel } from '@/api/sms/channel'
import jsPDF from 'jspdf'
export default {
  name: 'ZrInfo',
  mixins: [tableMixin],
  dicts: ['extra_sms_template_type'],
  components: {
    Recharge,
    ZRPanelGroup,
  },
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      sendSmsOpen: false,
      sendSmsForm: {
        params: [], // 模板的参数列表
      },
      sendSmsRules: {
        mobile: [{ required: true, message: '手机不能为空', trigger: 'blur' }],
        templateCode: [{ required: true, message: '模版编码不能为空', trigger: 'blur' }],
        templateParams: {},
      },
      search: false,
      // 遮罩层
      loading: true,
      activeName: 'template',
      signList: [],
      signOpen: false,
      signTitle: '',
      defaultSign: '',
      signForm: {},
      signRules: {
        sign: [{ required: true, message: '签名名称不能为空', trigger: 'blur' }],
        description: [{ required: true, message: '应用场景不能为空', trigger: 'blur' }],
      },

      signColumns: [
        // {
        //   title: '签名Id',
        //   dataIndex: 'signId',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: 'appid',
        //   dataIndex: 'appid',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '签名',
        //   dataIndex: 'sign',
        //   align: 'center',
        // },
        {
          title: '用途',
          dataIndex: 'name',
          width: 200,
          align: 'center',
        },
        {
          title: 'code',
          dataIndex: 'code',
          align: 'center',
        },
        // {
        //   title: 'channelCode',
        //   dataIndex: 'channelCode',
        //   align: 'center',
        // },
        {
          title: '内容',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '审核状态',
          dataIndex: 'applyStatus',
          align: 'center',
          scopedSlots: { customRender: 'applyStatus' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '220px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],

      templateList: [],
      templateOpen: false,
      templateTitle: '',
      templateForm: {},
      templateRules: {
        name: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }],
        code: [{ required: true, message: '请输入模板编码', trigger: 'blur' }],
        content: [{ required: true, message: '模板内容不能为空', trigger: 'blur' }],
        categoryId: [{ required: true, message: '模板类型不能为空', trigger: 'blur' }],
        remark: [{ required: true, message: '模板描述不能为空', trigger: 'blur' }],
        autoAddNo: [{ required: true, message: '请选择是否同步三方', trigger: 'change' }],
        apiTemplateId: [{ required: true, message: '短信API模板编号不能为空', trigger: 'blur' }],
        appid: [{ required: true, message: '产品类型不能为空', trigger: 'change' }],
        syncThirdNo: [{ required: true, message: '请选择是否同步三方', trigger: 'change' }],
      },
      templateColumns: [
        // {
        //   title: '模板ID',
        //   dataIndex: 'template_id',
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '模板名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true,
          align: 'center',
        },
        {
          title: '短信API模板编号',
          dataIndex: 'apiTemplateId',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '模板编码',
          dataIndex: 'code',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '模板内容',
          dataIndex: 'content',
          align: 'center',
        },
        {
          title: '短信类型',
          dataIndex: 'template_status',
          align: 'center',
          scopedSlots: { customRender: 'template_status' },
        },
        {
          title: '审核状态',
          dataIndex: 'applyReply',
          align: 'center',
          scopedSlots: { customRender: 'applyStatus' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: '220px',
          align: 'center',
        },
      ],
      zrAccount: [],
      channelId: null,
    }
  },
  created() {
    this.channelId = this.$route.params && this.$route.params.id
    this.getTemplateList(this.channelId)
  },
  methods: {
    handleClick(tab, event) {
      if (tab === 'sign') {
        this.getSignList(this.channelId)
      } else if (tab === 'template') {
        this.getTemplateList(this.channelId)
      }
    },
    getSignList(id) {
      getSignList({ channelId: id }).then((response) => {
        this.loading = false
        if (response.code === '20001') {
          this.defaultSign = response.sing
          this.signList = response.data.records
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    getTemplateList(id) {
      getTemplateList(id).then((response) => {
        this.loading = false
        if (response.code === '20001') {
          this.templateList = response.data.records
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    handleSignAdd() {
      this.signOpen = true
      this.signTitle = '添加签名'
      this.signReset()
    },
    handleSignUpdate(row) {
      this.signForm = {
        id: row.id,
        sign: row.sign,
        description: row.description,
      }
      this.signOpen = true
      this.signTitle = '修改签名'
    },
    handleSignDelete(row) {
      delSign(this.channelId, row.id)
        .then((response) => {
          this.getSignList(this.channelId)
          if (response.code === 0) {
            this.$message.success('删除成功')
          } else {
            this.$message.error(response.msg)
          }
        })
        .catch(() => {})
    },
    submitSignForm() {
      this.$refs.signForm.validate((valid) => {
        if (valid) {
          if (this.signForm.id != undefined) {
            updateSign(this.channelId, this.signForm.id, this.signForm.sign, this.signForm.description).then(
              (response) => {
                if (response.code === 0) {
                  this.signOpen = false
                  this.$message.success('修改成功')
                } else {
                  this.$message.error(response.msg)
                }
                this.getSignList(this.channelId)
              },
            )
          } else {
            const signData = {
              id: this.channelId,
              sign: this.signForm.sign,
              description: this.signForm.description,
            }
            createSign(signData).then((response) => {
              if (response.code === 0) {
                this.signOpen = false
                this.$message.success('添加成功')
              } else {
                this.$message.error(response.msg)
              }

              this.getSignList(this.channelId)
            })
          }
        }
      })
    },
    cancelSign() {
      this.signOpen = false
      this.signReset()
    },
    signReset() {
      this.signForm = {
        id: undefined,
        sign: undefined,
        description: undefined,
      }
      this.$nextTick(() => {
        this.$refs.signForm.resetFields()
      })
    },
    handleTemplateAdd() {
      if (this.templateOpen) {
        this.templateOpen = false
        this.templateReset()
        this.$nextTick(() => {
          this.templateOpen = true
          this.templateTitle = '添加模板'
          this.$nextTick(() => {
            this.forceResetTemplateForm()
          })
        })
      } else {
        this.templateReset()
        this.templateOpen = true
        this.templateTitle = '添加模板'
        this.$nextTick(() => {
          this.forceResetTemplateForm()
        })
      }
    },
    handleTemplateUpdate(row) {
      console.log(row)
      this.templateOpen = true
      this.templateForm = {
        id: row.id,
        categoryId: row.categoryId || 1,
        channelId: row.channelId,
        code: row.code,
        content: row.content,
        name: row.name,
        remark: row.remark,
        tenantId: row.tenantId,
        unsubscribe: row.unsubscribe,
        autoAddNo: row.autoAddNo !== undefined ? row.autoAddNo : 1,
        apiTemplateId: row.apiTemplateId,
        appid: row.appid || '49',
        syncThirdNo: row.syncThirdNo !== undefined ? row.syncThirdNo : row.autoAddNo !== undefined ? row.autoAddNo : 1,
      }
      this.updateCodeValidation()
      this.templateTitle = '修改模板'
      this.$nextTick(() => {
        if (this.$refs['templateForm']) {
          this.$refs['templateForm'].clearValidate()
        }
      })
    },
    handleTemplateDel(row) {
      delTemplate(row.id)
        .then((response) => {
          this.getTemplateList(this.channelId)
          if (response.code === '20001') {
            this.$message.success('删除成功')
          } else {
            this.$message.error(response.msg)
          }
        })
        .catch(() => {})
    },
    cancelTemplate() {
      this.templateOpen = false
      this.templateReset()
    },
    templateReset() {
      if (this.$refs['templateForm']) {
        this.$refs['templateForm'].clearValidate()
        this.$refs['templateForm'].resetFields()
      }
      const resetForm = {
        id: undefined,
        categoryId: 1,
        channelId: undefined,
        code: '',
        content: '',
        name: '',
        remark: '',
        tenantId: undefined,
        unsubscribe: undefined,
        autoAddNo: 1,
        apiTemplateId: '',
        appid: '49',
        syncThirdNo: 1,
      }
      this.templateForm = Object.assign({}, resetForm)
      this.updateCodeValidation()
      this.$nextTick(() => {
        if (this.$refs['templateForm']) {
          this.$refs['templateForm'].resetFields()
          this.$refs['templateForm'].clearValidate()
        }
      })
    },
    forceResetTemplateForm() {
      if (this.$refs['templateForm']) {
        this.$refs['templateForm'].resetFields()
        this.$refs['templateForm'].clearValidate()
        const resetForm = {
          id: undefined,
          categoryId: 1,
          channelId: undefined,
          code: '',
          content: '',
          name: '',
          remark: '',
          tenantId: undefined,
          unsubscribe: undefined,
          autoAddNo: 1,
          apiTemplateId: '',
          appid: '49',
          syncThirdNo: 1,
        }
        Object.keys(resetForm).forEach((key) => {
          this.$set(this.templateForm, key, resetForm[key])
        })
      }
    },
    handleAutoAddChange() {
      this.updateCodeValidation()
      if (this.templateForm.autoAddNo === 0) {
        this.templateForm.apiTemplateId = undefined
      }
    },
    updateCodeValidation() {
      if (this.templateForm.id) {
        this.templateRules.appid = [{ required: true, message: '产品类型不能为空', trigger: 'change' }]
        this.templateRules.syncThirdNo = [{ required: true, message: '请选择是否同步三方', trigger: 'change' }]
        this.templateRules.code = []
        this.templateRules.apiTemplateId = []
        this.templateRules.categoryId = []
        this.templateRules.autoAddNo = []
      } else {
        this.templateRules.code = [{ required: true, message: '请输入模板编码', trigger: 'blur' }]
        this.templateRules.categoryId = [{ required: true, message: '模板类型不能为空', trigger: 'blur' }]
        this.templateRules.autoAddNo = [{ required: true, message: '请选择是否同步三方', trigger: 'change' }]
        if (this.templateForm.autoAddNo === 1) {
          this.templateRules.apiTemplateId = [{ required: true, message: '短信API模板编号不能为空', trigger: 'blur' }]
        } else {
          this.templateRules.apiTemplateId = []
        }
        this.templateRules.appid = []
        this.templateRules.syncThirdNo = []
      }
      if (this.$refs['templateForm']) {
        this.$refs['templateForm'].clearValidate()
      }
    },
    submitTemplateForm() {
      this.$refs['templateForm'].validate((valid) => {
        if (valid) {
          if (this.templateForm.id != undefined) {
            const updateData = {
              id: this.templateForm.id,
              appid: this.templateForm.appid,
              content: this.templateForm.content,
              name: this.templateForm.name,
              remark: this.templateForm.remark,
              syncThirdNo: this.templateForm.syncThirdNo,
            }
            updateTemplate(updateData).then((response) => {
              if (response.code === '20001' || response.success) {
                this.templateOpen = false
                this.$message.success('修改成功')
              } else {
                this.$message.error(response.msg || response.message)
              }
              this.getTemplateList(this.channelId)
            })
          } else {
            const createData = {
              apiTemplateId: this.templateForm.autoAddNo === 1 ? this.templateForm.apiTemplateId : undefined,
              autoAddNo: this.templateForm.autoAddNo,
              categoryId: String(this.templateForm.categoryId),
              channelId: this.channelId,
              code: this.templateForm.code,
              content: this.templateForm.content,
              name: this.templateForm.name,
              remark: this.templateForm.remark,
              tenantId: this.templateForm.tenantId || 0,
              unsubscribe: this.templateForm.unsubscribe || '',
            }
            createTemplate(createData).then((response) => {
              if (response.code === '20001' || response.success) {
                this.templateOpen = false
                this.$message.success('添加成功')
                // 延迟500ms刷新列表，确保审核状态已更新
                setTimeout(() => {
                  this.getTemplateList(this.channelId)
                }, 500)
              } else {
                this.$message.error(response.msg || response.message)
              }
            })
          }
        }
      })
    },
    confirmHandleSignUse(row) {
      getChannel(this.channelId).then((response) => {
        const form = response.data
        form.signature = '【' + row.sign + '】'
        const that = this
        updateChannel(form).then((response) => {
          if (response.success) {
            this.getSignList(this.channelId)
            this.$message.success('修改默认签名成功')
          } else {
            this.$message.error(response.message)
          }
        })
      })
    },
    /** 同步掌榕短信模板到平台**/
    handleTemplateSyn(row) {
      synTemplate(this.channelId, row.id).then((response) => {
        if (response.code === 0) {
          this.$message.success('同步成功')
          this.getTemplateList(this.channelId)
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    handleSendSms(row) {
      this.resetSendSms(row)
      this.sendSmsForm.content = row.content
      this.sendSmsForm.params = row.params
      this.sendSmsForm.channelId = row.channelId
      this.sendSmsForm.templateCode = row.code
      this.sendSmsForm.templateParams = row.params.reduce(function (obj, item) {
        obj[item] = undefined
        return obj
      }, {})
      this.sendSmsRules.templateParams = row.params.reduce(function (obj, item) {
        obj[item] = { required: true, message: '参数 ' + item + ' 不能为空', trigger: 'change' }
        return obj
      }, {})
      this.sendSmsOpen = true
    },
    resetSendSms() {
      this.sendSmsForm = {
        content: undefined,
        params: undefined,
        mobile: undefined,
        templateCode: undefined,
        templateParams: {},
      }
    },
    cancelSendSms() {
      this.sendSmsOpen = false
      this.resetSendSms()
    },
    submitSendSmsForm() {
      const sendSmsForm = JSON.parse(JSON.stringify(this.sendSmsForm))
      const arr = Object.keys(sendSmsForm.templateParams).map((key) => sendSmsForm.templateParams[key])
      const obj = {}
      arr.forEach((value, index) => {
        obj[index + 1] = value
      })
      sendSmsForm.templateParams = obj
      sendSms(sendSmsForm).then((response) => {
        if (response.success) {
          this.$message.success('提交发送成功！发送结果，见发送日志编号：' + response.data)
          this.sendSmsOpen = false
        } else {
          this.$message.error(response.message)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.dashboard-editor-container {
  padding: 5px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .content-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
.right-toolbar-class {
  position: relative;
  top: 36px;
  right: 10px;
  z-index: 10;
}
.table-content-class {
  margin-top: -10px;
  margin-bottom: 20px;
}
.tips {
  background-color: #fef0f0;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 20px;
  color: #999;
  width: 100%;
  margin-bottom: 5px;
  margin-top: 5px;
}
@media (max-width: 1024px) {
  .content-wrapper {
    padding: 8px;
  }
}
/deep/.ant-tabs-tab {
  border: none !important;
  padding-top: 0 !important;
}
</style>
